import styled, { FlattenSimpleInterpolation, css } from 'styled-components'
import { colors } from 'const/colors'
import { HorizontalRuleProps } from './typing'

export const getHorizontalBarCss = (
  titleBar: string,
  borderColor?: string
): FlattenSimpleInterpolation => {
  return css`
    margin-left: 0;
    border-top: 3px solid ${borderColor || titleBar};
    width: 40px;
    text-align: left;
  `
}

export const HR = styled.hr<HorizontalRuleProps>`
  margin-top: ${({ topSpacing }): string => topSpacing || '32px'};
  margin-bottom: ${({ bottomSpacing }): string => bottomSpacing || '32px'};
  border-top: 1px solid ${colors.greyThirty};
  border-right: none;
  border-bottom: none;
  border-left: none;
  width: 100%;
  ${({ isTitleBorder, borderColor, theme }) =>
    isTitleBorder && getHorizontalBarCss(theme.titleBar, borderColor)};
`
